// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyCYYxT9hDwEGzNey1MPYdzPycGrl2e_sgs",
  authDomain: "xiicongresoabejasnativas.firebaseapp.com",
  projectId: "xiicongresoabejasnativas",
  storageBucket: "xiicongresoabejasnativas.appspot.com",
  messagingSenderId: "91759401079",
  appId: "1:91759401079:web:b64c7c562a3276d9d94e72",
  measurementId: "G-9VWVHXJ18M"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/xiicongresoabejasnativas.appspot.com/o/'